import { Injectable, inject, signal } from '@angular/core';
import { ApiService } from '../../core/api.service';
import { environment } from '../../../environments/environment';

export interface SettingsData {
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private api = inject(ApiService);
  private urlPath = `${environment.api.url}/ui/private/settings`;

  settings = signal<SettingsData | null>(null);

  loadSettings() {
    return this.api.get<SettingsData>(`${this.urlPath}/get-settings`).subscribe(data => {
      this.settings.set(data);

    });
  }

  saveSettings(settings: SettingsData) {
    return this.api.post<SettingsData>(`${this.urlPath}/save-settings`, settings);
  }
}
